exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tags-cloud__tag__jxy8M{margin-right:4px;margin-bottom:4px}", "", {"version":3,"sources":["/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/tags-cloud/src/widget/components/tags-cloud/tags-cloud.styl","/home/builduser/agent23/work/c8e02a04a4ed599f/src/widget/components/tags-cloud/tags-cloud.styl"],"names":[],"mappings":"AAAA,wBACE,iBAAA,iBACA,CCCD","file":"tags-cloud.styl","sourcesContent":[".tag\n  margin-right 4px\n  margin-bottom 4px\n",".tag {\n  margin-right: 4px;\n  margin-bottom: 4px;\n}\n/*# sourceMappingURL=src/widget/components/tags-cloud/tags-cloud.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"tag": "tags-cloud__tag__jxy8M"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/tags-cloud/tags-cloud.styl
// module id = 1989
// module chunks = 66